import { jsx as d } from "react/jsx-runtime";
import { c as m } from "../clsx-OuTLNxxd.js";
import { a as e } from "../background-bUl5ds8G.js";
const g = "SectionDivider-module_section-divider__LnGwj",
  l = "SectionDivider-module_spacing-top-regular__44rhg",
  u = "SectionDivider-module_spacing-bottom-regular__xZCRn",
  _ = "SectionDivider-module_spacing-top-compact__wh4Xi",
  C = "SectionDivider-module_spacing-bottom-compact__D-JQ0",
  v = "SectionDivider-module_spacing-top-condensed__DqMVl",
  D = "SectionDivider-module_spacing-bottom-condensed__OsSJ6",
  o = {
    sectionDivider: g,
    spacingTopRegular: l,
    spacingBottomRegular: u,
    spacingTopCompact: _,
    spacingBottomCompact: C,
    spacingTopCondensed: v,
    spacingBottomCondensed: D
  },
  R = _ref => {
    let {
      className: c,
      backgroundColorTop: i = "transparent",
      backgroundColorBottom: s = "transparent",
      spacingTop: n = null,
      spacingBottom: t = null,
      children: a,
      dataContentName: p = null
    } = _ref;
    const r = {
      "--background-top": e(i),
      "--background-bottom": e(s)
    };
    return /* @__PURE__ */d("div", {
      style: r,
      className: m(c, {
        [o.sectionDivider]: !0,
        [o.spacingTopRegular]: n == "regular",
        [o.spacingBottomRegular]: t == "regular",
        [o.spacingTopCompact]: n == "compact",
        [o.spacingBottomCompact]: t == "compact",
        [o.spacingTopCondensed]: n == "condensed",
        [o.spacingBottomCondensed]: t == "condensed"
      }),
      "data-content-name": p,
      children: a
    });
  };
export { R as SectionDivider };